module.exports = __webpack_public_path__ + "static/media/25UNHCR3.64e94e85.jpg";